import React, { Component } from "react";
import axios from 'axios';
import Config from '../Config'
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import logos from '../layout/pageheader.jpeg'


export default class Answers extends Component {
    constructor () {
        super()
        this.config = new Config()
        this.$http = this.config.DConnect()
        this.state = {
            itm: {}, mainpost: [], media: [],
        }
    }
    // const [posts, setPosts] = useState([]);
    // let params = useParams();
    // //const { match: { params } } = this.props.match.params
    // alert(JSON.stringify( params))
    // let postid = //params.answersid
    // useEffect(() => {
    //     const fetchPosts = async () => {
    //         const res = await axios.get(new Config().BaseURL() + 'category/fetchallknowledgebaseid/' + postid);
    //         alert(JSON.stringify(res.data))
    //         setPosts(res.data);
    //     };
    //     fetchPosts();
    // }, []);
    componentDidMount() {
        const { match: { params } } = this.props
        let answersid = params.answersid
        this.getDetails(answersid)
    }

    componentDidUpdate(nextProps) {
        if (nextProps.answersid !== this.props.answersid) {
            const { match: { params } } = nextProps
            let answersid = params.answersid
            this.getDetails(answersid)
        }
    }
    getDetails = (id) => {
        this.$http.get('category/fetchallknowledgebaseid/' + id)
            .then(res => {
                let itm = res.data
                this.getMedia(itm.ticketid)
                this.setState({ itm })
            })
    }

    getMedia = (id) => {
        this.$http.get('media/fetchmedia/' + id)
            .then(res => {
                let media = res.data
                this.setState({ media })
            })
    }

    imageFormats = (id, subject) => {
        let mainpost = this.state.media.filter(itm => itm.msgid == id)
        let post = []
        if (mainpost != '') {
            post = mainpost
        }

        return (
            <span style={{color:"black"}}>
                {
                    post.map(itm =>
                        <a href={this.config.Downloadlink() + itm.attachments} target="_blank">{subject}</a>

                    )
                }
            </span>
        )
    }

    categoryFormat = (id) => {
        // let depa = this.state.category.filter(itm => itm.id == id)
        // let name = (depa != '') ? depa[0].name : id
        // return name
    }

    render() {
        let itm = this.state.itm
        return (
            <div>

                <div class="hero-section bg_img style-two" data-background={logos}>
                    <div class="container">
                        <div class="cate-header cl-white">
                            <h1 class="cate-title">{itm.subject}</h1>
                            <div class="cate-meta">
                                <div class="left">
                                    <span>{itm.createdon}</span>
                                    <div class="thumb">
                                        <a href="#0">{itm.updateon}</a>
                                    </div>
                                    <h6 class="subtitle"><a href="#0">{itm.updateon}</a></h6>

                                </div>

                                <div class="right">
                                    <i class="flaticon-view-files"></i><span>{this.categoryFormat(itm.category)}</span>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <section class="category-section padding-bottom mt--160 pos-rel">
                    <div class="container">
                        <div class="category-single-wrapper">
                            <div class="single-item">
                                <h2 class="title">{itm.subject}</h2>
                                <p>{ReactHtmlParser(itm.message)}</p>

                            </div>
                            <ul>
                                <li style={{ fontSize: "14px", color: "black" }}>

                                    {(this.state.media != '') ?
                                        this.imageFormats(itm.ticketid, itm.subject) :
                                        <p>No Attachement</p>
                                    }
                                </li>
                            </ul>
                        </div>
                    </div>
                </section>


                {/* <div class="page-top-block" data-ix="hide-fixed-top-bar">
                    <div class="container w-container">
                        <div class="top-bar-title-wrapper w-hidden-medium w-hidden-small w-hidden-tiny">
                            <h2 class="top-bar-heading">How to deposit money in your account</h2>
                            <div class="top-bar-title-gradient-overlay"></div>
                        </div>
                        <div class="top-bar-buttons-wrapper w-clearfix">
                            <div class="category-dropdown w-dropdown" data-delay="0">
                                <div class="category-dropdown-toggle w-dropdown-toggle">
                                    <div>View&nbsp;<strong>Categories</strong></div>
                                    <div class="dropdown-icon w-icon-dropdown-toggle"></div>
                                </div>
                                <nav class="dynamic-dropdownlist w-dropdown-list">
                                    <div class="dropdown-list-wrapper w-dyn-list">
                                        <div class="dynamic-dropdown-list w-dyn-items">
                                            <div class="dropdown-item w-dyn-item"><a class="dynamic-dropdown-link" href="/categories/customization">Customization</a></div>
                                            <div class="dropdown-item w-dyn-item"><a class="dynamic-dropdown-link" href="/categories/for-companies">For Companies</a></div>
                                            <div class="dropdown-item w-dyn-item"><a class="dynamic-dropdown-link" href="/categories/for-developers">For Developers</a></div>
                                            <div class="dropdown-item w-dyn-item"><a class="dynamic-dropdown-link" href="/categories/for-freelancers">For Freelancers</a></div>
                                            <div class="dropdown-item w-dyn-item"><a class="dynamic-dropdown-link" href="/categories/webdesign">Webdesign</a></div>
                                            <div class="dropdown-item w-dyn-item"><a class="dynamic-dropdown-link" href="/categories/your-account">Your Account</a></div>
                                        </div>
                                    </div>
                                </nav>
                            </div>
                            <a class="fixed icon-button w-clearfix w-inline-block" href="/contact-us">
                                <div class="icon-button-icon"></div>
                                <div class="icon-button-title">Contact us</div>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="article-section section">
                    <div class="container w-container">
                        <div class="article-block-left">

                            <h4 class="" data-ix="show-fixed-top-bar">{itm.subject}</h4>
                            <div class="article-info-wrapper">
                                <div class="article-info-block date">
                                    <div class="article-info-title"><strong>Created</strong>:</div>
                                    <div class="article-info-title dynamic">{itm.createdon}</div>
                                </div>
                                <div class="article-info-block date last">
                                    <div class="article-info-title"><strong>Updated</strong>:</div>
                                    <div class="article-info-title dynamic">{itm.updateon}</div>
                                </div>
                            </div>


                            <div class="rich-text-block w-richtext">
                                <span style={{ color: "red" }}><b>Answer:</b></span>
                                <p><h5>{ReactHtmlParser(itm.message)}</h5></p>


                            </div>

                        </div>
                        <div class="article-block-right">

                            <div class="sidebar-block-wrapper">
                                <div class="sidebar-block">
                                    <div class="sidebar-content-block">
                                        <div class="sidebar-content-title" style={{ fontSize: "12px" }}>{(this.state.media != '') ? "Click to download" : "Attachments"}</div>

                                        <ul>
                                            <li style={{ fontSize: "14px" }}>

                                                {(this.state.media != '') ?

                                                    this.imageFormats(itm.ticketid, itm.subject) :

                                                    <p>No Attachement</p>
                                                }
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div> */}
            </div>
        )
    }
}
